import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon", "children", "isRound", "aria-label"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { Button } from "./chunk-NAA7TEES.mjs";

// src/icon-button.tsx
import { forwardRef } from "@chakra-ui/system";
import { cloneElement, isValidElement } from "react";
import { jsx } from "react/jsx-runtime";
var IconButton = forwardRef(function (props, ref) {
  var icon = props.icon,
    children = props.children,
    isRound = props.isRound,
    ariaLabel = props["aria-label"],
    rest = _objectWithoutProperties(props, _excluded);
  var element = icon || children;
  var _children = isValidElement(element) ? cloneElement(element, {
    "aria-hidden": true,
    focusable: false
  }) : null;
  return /* @__PURE__ */jsx(Button, _objectSpread(_objectSpread({
    padding: "0",
    borderRadius: isRound ? "full" : void 0,
    ref: ref,
    "aria-label": ariaLabel
  }, rest), {}, {
    children: _children
  }));
});
IconButton.displayName = "IconButton";
export { IconButton };